import aspectStoreModule from '@/app/aspect/apsect-state';

const documentTitleSeparator: string = ' | ';

export const setDocumentTitle = (items: string[] = []): void => {
  if (aspectStoreModule.selectedCourseAspectInstance !== null) {
    items = [...items, aspectStoreModule.selectedCourseAspectInstance.title];
  }

  items = [...items ];

  document.title = items.join(documentTitleSeparator);
};
